import React, { useState, useEffect } from 'react';
import styles from './index.module.sass';
import TableBusinessSimulator from '../../TableBusinessSimulator';
import { useTranslation } from 'react-i18next';
import OrderCard from '../../OrderCard';
import getSimulador from '../../Queries/getSimulador';
import Alert from '../../Alert';

const BusinessSimulator = (props) => {
  const { device, webservice, getCookie, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('business');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);

  const [listCentralGroup, getCentralGroup] = useState([]);
  const [listFrontLine, getFrontLine] = useState([]);
  const [fields, setFields] = useState({
    sponsorshipGC: 60,
    sponsorshipPL: 60,
    activeConsultantsGC: 5,
    activeConsultantsPL: 5,
    leadersGC: 0,
    leadersPL: 5,
  });

  const tableFields = t('tableFields', { returnObjects: true });

  const Change = (e) => {
    setFields({
      ...fields,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    async function Show() {
      const response = await getSimulador(
        fields.sponsorshipGC,
        fields.activeConsultantsGC,
        fields.leadersGC,
        fields.sponsorshipPL,
        fields.activeConsultantsPL,
        fields.leadersPL,
      );
      setSessionMessage(response.mensaje);
      if (response.body.tipoMensaje === 'exito') {
        const arrtmpGC = [
          response.body.tabla1_GrupoCentral.TotalConsultorasGC,
          response.body.tabla1_GrupoCentral.comisiones1aLinea,
          response.body.tabla1_GrupoCentral.comisionesGC,
          response.body.tabla1_GrupoCentral.comisionesGCy1aLinea,
          response.body.tabla1_GrupoCentral.consultorasActivasGC,
          response.body.tabla1_GrupoCentral.gruposPerdidos,
          response.body.tabla1_GrupoCentral.lideresEnLaPrimeraLinea,
          response.body.tabla1_GrupoCentral.nuevasConsultorasPatrocinando,
          response.body.tabla1_GrupoCentral.numConsultorasDesprendidas,
          response.body.tabla1_GrupoCentral.numDeGruposDirectos,
          response.body.tabla1_GrupoCentral.porcientoNuevosPatrocinios,
          response.body.tabla1_GrupoCentral.titulo,
        ];
        getCentralGroup(arrtmpGC);

        const arrtmpPL = [
          response.body.tabla2_PrimeraLinea.comisionesGC,
          response.body.tabla2_PrimeraLinea.consultorasActivasGC,
          response.body.tabla2_PrimeraLinea.gruposEnPromocion,
          response.body.tabla2_PrimeraLinea.gruposPerdidos,
          response.body.tabla2_PrimeraLinea.lideresEnLaPrimeraLinea,
          response.body.tabla2_PrimeraLinea.noConsultorasDesprendidas,
          response.body.tabla2_PrimeraLinea.noGruposDirectos,
          response.body.tabla2_PrimeraLinea.nuevasConsultorasPatrocinando,
          response.body.tabla2_PrimeraLinea.porcientoNuevosPatrocinios,
          response.body.tabla2_PrimeraLinea.titulo,
          response.body.tabla2_PrimeraLinea.totalConsultorasGC,
        ];
        getFrontLine(arrtmpPL);
      } else {
        setAlertText(t('messageAlert'));
        setOpen(true);
      }
    }
    Show();
  }, [
    fields.activeConsultantsGC,
    fields.activeConsultantsPL,
    fields.leadersGC,
    fields.leadersPL,
    fields.sponsorshipGC,
    fields.sponsorshipPL,
    getCookie,
    webservice,
    t,
    setSessionMessage,
  ]);

  return (
    <div id={styles.Validate} className={`${styles[screenSize]} ${styles.simulator}`}>
      <div className={styles.container}>
        <Alert open={open} setOpen={setOpen} title={t('titleAlert')} text={alertText} />
        <div className={styles.goldTitle}>{t('title')}</div>
        <div className={styles.blueSubtitle}>{t('title2')}</div>
        <br />
        <OrderCard>
          <div className={styles.subTitle}>{t('section1')}</div>
          <div className={`${styles.components} ${styles[screenSize]}`}>
            <div className={styles.subComponents}>
              <label className={`${styles.label} ${styles[screenSize]}`}>
                % {t('label1')}:&nbsp;
              </label>
              <input
                type='number'
                className={`${styles.inputNumber} ${styles[screenSize]}`}
                value={fields.sponsorshipGC}
                onChange={(e) => Change(e)}
                name='sponsorshipGC'
              />
            </div>
            <div className={styles.subComponents}>
              <label className={`${styles.label} ${styles[screenSize]}`}>
                {t('label2')}:&nbsp;
              </label>
              <input
                type='number'
                className={`${styles.inputNumber} ${styles[screenSize]}`}
                value={fields.activeConsultantsGC}
                onChange={(e) => Change(e)}
                name='activeConsultantsGC'
              />
            </div>
            <div className={styles.subComponents}>
              <label className={`${styles.label} ${styles[screenSize]}`}>
                {t('label3')}:&nbsp;
              </label>
              <input
                type='number'
                className={`${styles.inputNumber} ${styles[screenSize]}`}
                value={fields.leadersGC}
                onChange={(e) => Change(e)}
                name='leadersGC'
              />
            </div>
            &nbsp;
          </div>
          <div>&nbsp;</div>
          <TableBusinessSimulator
            screenSize={screenSize}
            tableData={listCentralGroup}
            tableItems={tableFields}
            type={'t1'}
          />
        </OrderCard>

        <OrderCard>
          <div className={styles.subTitle}>{t('section2')}</div>
          <div className={`${styles.components} ${styles[screenSize]}`}>
            <div className={styles.subComponents}>
              <label className={`${styles.label} ${styles[screenSize]}`}>
                % {t('label1')}:&nbsp;
              </label>
              <input
                type='number'
                className={`${styles.inputNumber} ${styles[screenSize]}`}
                value={fields.sponsorshipPL}
                onChange={(e) => Change(e)}
                name='sponsorshipPL'
              />
            </div>
            <div className={styles.subComponents}>
              <label className={`${styles.label} ${styles[screenSize]}`}>
                {t('label2')}:&nbsp;
              </label>
              <input
                type='number'
                className={`${styles.inputNumber} ${styles[screenSize]}`}
                value={fields.activeConsultantsPL}
                onChange={(e) => Change(e)}
                name='activeConsultantsPL'
              />
            </div>
            <div className={styles.subComponents}>
              <label className={`${styles.label} ${styles[screenSize]}`}>
                {t('label3')}:&nbsp;
              </label>
              <input
                type='number'
                className={`${styles.inputNumber} ${styles[screenSize]}`}
                value={fields.leadersPL}
                onChange={(e) => Change(e)}
                name='leadersPL'
              />
            </div>
            &nbsp;
          </div>
          <div>&nbsp;</div>
          <TableBusinessSimulator
            screenSize={screenSize}
            tableData={listFrontLine}
            tableItems={tableFields}
            type={'t2'}
          />
        </OrderCard>
      </div>
    </div>
  );
};

export default BusinessSimulator;
